import $ from 'jquery';
window.$ = window.jQuery = $;

( function( $ ) {
	"use strict";

	var TLS_Forms = function() {

		var self = this;

        this.newsletter_init = function() {
            var footer = $('footer'),
            newsletter = footer.find('.newsletter'),
            input_container = newsletter.find('.ginput_container_email'),
            label_container = newsletter.find('.gfield--type-email'),
            label = label_container.find('label'),
            new_label = label.clone();
            label.hide();

            new_label.removeClass();

            new_label.appendTo(input_container);
        };

		this.fibosearch_init = function() {
			var form = $('form.dgwt-wcas-search-form');
			form.find('input[name=post_type]').remove();
			form.find('input[name=dgwt_wcas]').remove();
		};

		/**
		 * Event binding.
		 */
		this.bind = function() {
            $( document ).on( 'ready', self.newsletter_init );
			$( document ).on( 'ready', self.fibosearch_init );
		};

		/**
		 * Initialization.
		 */
		this.init = function() {
			self.bind();
		};

		this.init();

	};

	( new TLS_Forms() );

} )( jQuery );